import { useSelector } from "react-redux";
import SignupForm from "../Components/Log/SignupForm";
import Nav from "../Components/Nav/Nav";
import Login from "./Login";
import AdminMenu from "../Components/Admin/AdminMenu";
import AdminFormHeader from "../Components/Admin/AdminFormHeader";

const Signup = () => {
  const userData = useSelector((state) => state.userReducer);

  return (
    <>
      {userData.isAdmin ? (
        <>
          <Nav />
          <div className="mainContainer">
            <AdminMenu />
            <div className="centerBlock_admin">
              <AdminFormHeader
                title="Créer un utilisateur"
                subtitle="Ajoutez un nouveau membre à l'équipe et définissez ses accès."
              />
              <div className="useronline-container-admin">
                <div className="requestformation">
                  <>
                    <SignupForm />
                  </>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Login />
      )}
    </>
  );
};

export default Signup;
